import { Navigate } from 'react-router-dom'

/** Legacy route — case study management lives under Question Bank tab. */
const AdminQuestionGroupsPage = () => (
  <Navigate to="/admin/question-bank?tab=case-study" replace />
)

export default AdminQuestionGroupsPage
